export default __webpack_public_path__ + "static/bg-blue-cf3acfd56adb654efc72bb412a87f400.jpg";